export enum GeneralFilters {
    All = 'All',
    Appointments = 'Appointments',
}

export enum MeetingsFilters {
    AllMeetings = 'AllMeetings',
    Organizer = 'Organizer',
    Attendee = 'Attendee',
    Canceled = 'Canceled',
    Drafts = 'Drafts',
}

export enum RecurrenceFilters {
    Single = 'Single',
    Series = 'Series',
}

export enum ReservationsFilters {
    Desk = 'Desk',
}

export enum PrivacyFilters {
    Private = 'Private',
    NotPrivate = 'NotPrivate',
}

export enum InPersonFilters {
    Required = 'Required',
    NotRequired = 'NotRequired',
}

export enum CalendarEventsFilterType {
    General = 'General',
    Meetings = 'Meetings',
    Categories = 'Category',
    ShowAs = 'ShowAs',
    Recurrence = 'Recurrence',
    Privacy = 'Privacy',
    DeclinedEvents = 'DeclinedEvents',
    InPerson = 'InPerson',
    Reservations = 'Reservations',
    PollHolds = 'PollHolds',
    PriorityView = 'PriorityView',
}

export enum DeclinedEventsFilters {
    DeclinedEvents = 'DeclinedEvents',
}

export const CalendarEventsFilters: typeof GeneralFilters &
    typeof MeetingsFilters &
    typeof DeclinedEventsFilters = {
    ...GeneralFilters,
    ...MeetingsFilters,
    ...DeclinedEventsFilters,
};

export type CalendarEventsFilters =
    | GeneralFilters
    | MeetingsFilters
    | RecurrenceFilters
    | PrivacyFilters
    | DeclinedEventsFilters
    | ReservationsFilters;

export const CalendarFiltersTypes: typeof GeneralFilters & typeof CalendarEventsFilterType = {
    ...GeneralFilters,
    ...CalendarEventsFilterType,
};
export type CalendarFiltersTypes = GeneralFilters | CalendarEventsFilterType;

/* V2 Section */
export enum MeetingsFiltersV2 {
    Organizer = 'Organizer',
    Drafts = 'Drafts',
    Accepted = 'Accepted',
    DeclinedEvents = 'DeclinedEvents',
    Followed = 'Followed',
    Maybe = 'Maybe',
    Canceled = 'Canceled',
    NotResponded = 'NotResponded',
}

export enum OrganizerMeetingFilters {
    Organizer = 'Organizer',
    Drafts = 'Drafts',
}

export enum AttendeeMeetingFilters {
    Accepted = 'Accepted',
    DeclinedEvents = 'DeclinedEvents',
    Followed = 'Followed',
    Maybe = 'Maybe',
    Canceled = 'Canceled',
    NotResponded = 'Not Responded',
}

export enum OrganizerPollFilters {
    SeeAll = 'SeeAll',
}

export enum AttendeePollFilters {
    VotedYes = 'VotedYes',
    VotedNo = 'VotedNo',
    NotVoted = 'NotVoted',
}

export enum PollHoldsFilters {
    SeeAll = 'SeeAll',
    VotedYes = 'VotedYes',
    VotedNo = 'VotedNo',
    NotVoted = 'NotVoted',
}

export enum PriorityViewFilters {
    Priority = 'Priority',
    NonPriority = 'NonPriority',
}

export enum GeneralFiltersV2 {
    Appointments = 'Appointments',
    DeskBookings = 'DeskBookings',
}

export const CalendarEventsFiltersV2: typeof GeneralFiltersV2 & typeof MeetingsFiltersV2 = {
    ...GeneralFiltersV2,
    ...MeetingsFiltersV2,
};
export type CalendarEventsFiltersV2 =
    | GeneralFiltersV2
    | MeetingsFiltersV2
    | RecurrenceFilters
    | InPersonFilters
    | ReservationsFilters
    | PollHoldsFilters
    | PriorityViewFilters;
